import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {RecommendationGroupModel} from "../../../models/recommendation.model";

require('./recommendation-groups-list-items.scss');
@Component({
  standalone: false,
  selector: 'app-recommendation-groups-list-items',
  templateUrl: './recommendation-groups-list-items.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecommendationGroupsListItemsComponent implements OnChanges, AfterViewInit {

  @Input() recommendationGroups: RecommendationGroupModel[];
  @Input() loading: boolean;

  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onSelectGroup = new EventEmitter<RecommendationGroupModel>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  private hasRequestedNextBatch = false;

  constructor(@Inject('analyticsService') private analyticsService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.recommendationGroups) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
      // Reset flag when new data arrives
      if (changes.recommendationGroups.currentValue !== changes.recommendationGroups.previousValue) {
        this.hasRequestedNextBatch = false;
      }
    }

    // Reset flag when loading completes
    if (changes.loading && !changes.loading.currentValue && changes.loading.previousValue) {
      this.hasRequestedNextBatch = false;
    }
  }

  ngAfterViewInit(): void {
  }

  onSelectGroupClick(recommendationGroup: RecommendationGroupModel) {
    this.analyticsService.trackEvent('Recommendations Actions', 'recommendation_viewed', recommendationGroup.id);
    this.onSelectGroup.emit(recommendationGroup);
  }

  getNextBatch() {
    // Prevent multiple calls: check if loading, already requested, or not near bottom
    if (this.loading || this.hasRequestedNextBatch) {
      return;
    }

    const bottomOffset = this.cdkVirtualScrollViewport.measureScrollOffset('bottom');

    if (bottomOffset < 200) {
      this.hasRequestedNextBatch = true;
      this.fetchNextEvent.emit();
    }
  }
}

